export default __webpack_public_path__ + "static/media/16.56779985.png";